/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import { TextField } from '@material-ui/core';
import { Link, useHistory } from 'react-router-dom';
import { Button, Dropdown } from 'react-bootstrap';
import Box from '@material-ui/core/Box';
import _ from 'lodash';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Checkbox from '@material-ui/core/Checkbox';
import { useDispatch, useSelector } from 'react-redux';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import CommentVisibleIcon from '../../../../assets/images/commen-visible-icon.svg';
import CommentIcon from '../../../../assets/images/comment-dots.svg';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import SaveCancelPopup from '../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import {
  AuditDescriptionHeader,
  rebateProgramColumnDetails,
  TableHeaderForNDCLevelDetail,
} from './gridComponent/TableHeaders';
import {
  redirectURLLink,
  closeTab,
  handleRefreshCell,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import ClearAuditsForNDCPopup from './ClearAuditsForNDCPopup';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import {
  checkActionAccessByRole,
  tabHighLigther,
} from '../../../../SharedModules/utilities/utilities';
import {
  INPUT_VALUE_GRETER_THAN_TOTAL_COUNT,
  ERR_PAGINATE_VALUE,
  MNFC_NDC_ERROR_MSG,
  SUCCESSMESSAGE_GENERIC,
} from '../../../../SharedModules/Errors/constantMessageData';
import {
  getClaimDetails,
  storeClaimAction,
  getNdcDetailsCall,
  getClaimAuditDetails,
  getClaimAuditDescription,
  callSearchClaimAPI,
  updateClearedIndex,
  dispatchPageCountwithDetails,
  getSpecificAuditTypeData,
  dispatchClaimAuditDescription,
  dispatchErrorMessageData,
  dispatchUpdateClr,
  setChangesDataList,
} from '../store/actions';
import { getProviderIdTypeDetails } from '../../../Display/Provider/store/action';
import { setCurrentNDCDetailsSelected } from '../../../Display/NDC/store/action';

import {
  setSelectedClaim,
  setSelectedClaimMode,
  navigateToProvider,
  navigateToClaim,
  getClaimTableInfo,
} from '../../../Display/Claim/store/action';

import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import { getExistingCorrLinkIds } from '../../InvoiceAudits/store/Actions';
import CommentAndCorrespondenceComponent from '../../../../SharedModules/MicroFrontend/CommentAndCorrespondenceComponent';
import ViewHistoryComponent from '../../../../SharedModules/MicroFrontend/ViewHistoryComponent';
import {
  getUnitConversionDetail,
  getNdcGrid,
} from '../../../Maintain/unitConversion/store/actions';
import {
  setClaimSelectBy,
  setSelectedClaimModeNu as modeNOU,
  setSelectedClaim as claimNOU,
  getNOUClaimTableInfo,
  setSelectedClaimFilter,
  setClaimLoading,
  setNoOfUnitsSearchScreenObj,
  setSelectedClaimIndex,
  GetAndDispatchClaimByID,
  setEditedRows,
  setNumberOfUnitSelectBy,
} from '../../../Maintain/NumberOfUnits/store/action';
import showPreloader from '../../../../interceptor/store/Actions';
import CommonModal from '../../../../SharedModules/Dialog/CommonModal';

const ClaimAuditViewDetails = () => {
  const {
    claimAuditDetails,
    claimAuditDescription,
    updateClearedResponse,
    claimAuditDetail,
    pageCountwithDetails,
    selectedAuditType,
    errorMessageInRedux,
    changesDataList,
  } = useSelector((state) => state?.sharedState?.ClaimAuditReducer);

  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const logInUserID = useSelector((state) => state.sharedState.logInUserID);
  const searchClaimAuditSelectData = useSelector(
    (state) => state?.sharedState?.ClaimAuditReducer?.claimAuditSelectScreenData
  );

  const getExportAllDataForDetailScr = useSelector(
    (state) => state?.sharedState?.ClaimAuditReducer?.exportAllOnDetailScr
  );

  const commentsList = useSelector((state) => {
    return state.sharedState.CommentsReducer?.CommentListData;
  });
  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const history = useHistory();
  const dispatch = useDispatch();
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [fullScreenView1, setFullScreenView1] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [openCancel, setOpenCancel] = React.useState(false);
  const [clearAuditPopup, setClearAuditPopup] = React.useState(false);
  const [cancelAuditAlert, setCancelAuditAlert] = React.useState(false);
  const [warningAlert, setWarningAlert] = React.useState(false);
  const [auditFilterData, setAuditFilterData] = React.useState([]);
  const [clearAuditCount, setCLearAuditCount] = React.useState([]);
  const [clearAuditData, setClearAuditData] = React.useState({});
  const [disabledSaveCancelBtn, setDisabledSaveCancelBtn] =
    React.useState(false);
  const [claimAuditTable, setClaimAuditTable] = React.useState([]);
  const [auditDescriptionTable, setAuditDescriptionTable] = React.useState([]);
  const [gridApi, setGridApi] = React.useState(null);
  const [buttonDisable, setButtonDisable] = React.useState({
    save: true,
    cancel: true,
  });
  const [clearedIndexPayload, setClearedIndexPayload] = React.useState([]);
  const [successMessages, setSuccessMessages] = React.useState([]);
  const [claimPageDetails, setClaimPageDetails] = React.useState();
  const [totalCount, setTotalCount] = React.useState(0);
  const [errorMessages, setErrorMessages] = React.useState([]);
  const [disableBtn, setDisableBtn] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [clickOncloseTabBtn, setClickOncloseTabBtn] = React.useState(true);
  const [showViewHistory, setShowViewHistory] = React.useState(false);
  const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
  const [keyValue, setKeyValue] = React.useState([]);
  const [showComments, setShowComments] = React.useState(false);
  const [corrLinkId, setCorrLinkId] = React.useState(null);
  const [linkTableName, setLinkTableName] = React.useState('');
  const [tableName, setTableName] = React.useState('DRUG_QTR_DETAILS');
  const fetchClaimDetail = (value) => dispatch(getUnitConversionDetail(value));
  const [exportExcel, setExportExcel] = React.useState([]);
  const [tableGridApi, setTableGridApi] = React.useState([]);
  const [tableGridApiForAudit, setTableGridApiForAudit] = React.useState([]);
  const [stateCC, setStateCC] = React.useState(true);
  const [movePage, setMovePage] = React.useState(false);
  const [moveRight, setMoveRight] = React.useState(false);
  const [tableState, setTableState] = React.useState(false);
  const [selectedData, setSelectedData] = React.useState([]);
  const [isEnablebyRole, setIsEnablebyRole] = React.useState(
    checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
  );

  // reducer Values
  React.useEffect(() => {
    if (kcRoles?.userPrivileges.length > 0) {
      setIsEnablebyRole(
        checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
      );
    }
  }, []);
  // Set Pagination data
  React.useEffect(() => {
    if (claimAuditDetail?.status === '001') {
      setTotalCount(claimAuditDetail?.claimAuditResponse?.length);
      if (pageCountwithDetails && !_.isEmpty(pageCountwithDetails)) {
        dispatch(
          dispatchPageCountwithDetails({
            pageCount: pageCountwithDetails?.pageCount,
            inputList: pageCountwithDetails?.inputList,
          })
        );
      } else {
        dispatch(
          dispatchPageCountwithDetails({
            pageCount: 1,
            inputList: claimAuditDetail?.claimAuditResponse[0],
          })
        );
      }
    }
  }, [claimAuditDetail]);

  // React.useEffect(() => {
  //   dispatch(
  //     dispatchPageCountwithDetails({
  //       pageCount: 1,
  //       inputList: claimAuditDetail?.claimAuditResponse?.[0],
  //     })
  //   );
  // }, [claimAuditDetail]);

  // NDC data API call
  const getTableList = () => {
    if (pageCountwithDetails?.inputList?.drugSeqNum)
      dispatch(
        getClaimAuditDetails({
          adtFrom: searchClaimAuditSelectData?.searchData?.myAuditOnly
            ? searchClaimAuditSelectData?.searchData?.fromDateRangeForMyAudit
            : searchClaimAuditSelectData?.searchData?.paidDateRangeFrom,
          adtTo: searchClaimAuditSelectData?.searchData?.myAuditOnly
            ? searchClaimAuditSelectData?.searchData?.toDateRangeForMyAudit
            : searchClaimAuditSelectData?.searchData?.paidDateRangeTo,
          programcd: searchClaimAuditSelectData?.searchData?.rebateProgramCd,
          claimReversalInd: searchClaimAuditSelectData?.searchData?.reversed,
          claimUnReversalInd:
            searchClaimAuditSelectData?.searchData?.unreversed,
          auditClearedInd: searchClaimAuditSelectData?.searchData?.clearAudit,
          drugseqnum: [pageCountwithDetails?.inputList?.drugSeqNum],
          claimaudittype: searchClaimAuditSelectData?.searchData?.auditType,
          claimspctype: searchClaimAuditSelectData?.searchData?.speAuditType,
          claimgrptypeUA:
            searchClaimAuditSelectData?.searchData?.amountAudit === 1
              ? 'UA'
              : null,
          claimgrptypeUCA:
            searchClaimAuditSelectData?.searchData?.unitConversionAudit === 1
              ? 'UCA'
              : null,
          claimgrptypeOA:
            searchClaimAuditSelectData?.searchData?.otherAudit === 1
              ? 'OA'
              : null,
          lastUpdateUserId: logInUser,
        })
      );
  };

  // Call Pagination API on page count change
  React.useEffect(() => {
    if (pageCountwithDetails) {
      setClaimPageDetails(pageCountwithDetails);
      setLoading(true);
      getTableList();
    }
  }, [pageCountwithDetails]);

  React.useEffect(() => {
    dispatch(storeClaimAction(''));
  }, []);
  React.useEffect(() => {
    if (!changesDataList?.length > 0) {
      setButtonDisable({ save: true, cancel: true });
    } else {
      setButtonDisable((prev) => ({
        ...prev,
        save: false,
        cancel: false,
      }));
    }
  }, [changesDataList]);
  const navigateToSelectedClaimScreen = () => {
    redirectURLLink(
      '/units-selected-claim',
      'Units Selected Claim',
      history,
      dispatch
    );
    dispatch(setSelectedClaimIndex(1));
    history.push({
      pathname: '/units-selected-claim',
    });
  };
  // Modify units Redirection API Call
  const handleViewDetailsForUnits = async (
    data,
    userId,
    searchScreenReduxObj
  ) => {
    dispatch(setClaimLoading(true));
      dispatch(modeNOU('maintain'));
    dispatch(setNumberOfUnitSelectBy('claimId'));
      dispatch(
      GetAndDispatchClaimByID(
        {
          claimId: data?.claimid,
          userID: userId,
          drugSeqNum: data?.drugSeqNum, 
          filterByDrugSeqNum: true
        },
        () => {
          navigateToSelectedClaimScreen();
        },
        true,
        true
      )
      );
    dispatch(setEditedRows([]));
      dispatch(
        setNoOfUnitsSearchScreenObj({
          ...searchScreenReduxObj,
          isibwdndc: true,
          isibwdclaim: false,
        })
      );
  };

  // Go to Claims redirection API call
  const handleViewDetailsForClaims = async (
    data,
    searchClaimAuditSelectObj
  ) => {
    // const response = await callSearchClaimAPI({
    //   claimId: data?.claimid,
    // });

    // if (response.message === 'Success') {
    //   dispatch(setSelectedClaimMode('display'));
    //   dispatch(setSelectedClaim(response?.data));
    //   redirectURLLink('/selected-claim', 'Selected Claim', history, dispatch);
    // }
    setLoading(true);
    dispatch(getClaimTableInfo(true));
    dispatch(
      navigateToClaim(
        {
          rebateProgramCd:
            searchClaimAuditSelectObj?.searchData.rebateProgramCd,
          rebateProgramCdAll: 0,
          paidQtr: `${data?.paidDt?.substr(4)}Q${data?.paidDt?.substr(0, 4)}`,
          searchByNdc: true,
          client: null,
          group: null,
          claimCategoryCd: null,
          plan: null,
          userID: logInUser,
          // functionCode: 'Claim',
          // eventInquryKeyVO: [
          //   {
          //     keyType: 'NDC',
          //     key: `${claimPageDetails?.inputList?.labelerCode}-${claimPageDetails?.inputList?.productCode}-${claimPageDetails?.inputList?.packageSize}`,
          //   },
          // ],
          drugSqnNum: [data.drugSeqNum],
        },
        () => {
          redirectURLLink(
            '/selected-claim',
            'Selected Claim',
            history,
            dispatch
          );
          // navigateToPage('/selected-claim', 'Selected Claim');
        }
      )
    );
  };

  // Go to NDC redirection API Call
  const getNdcData = async (cellInfo) => {
    setLoading(true);
    const { drugName, ndc } = cellInfo;
    const response = await getNdcDetailsCall([
      {
        ndc: ndc,
        drugName: drugName,
      },
    ]);

    if (response.message === 'SUCESS') {
      dispatch(setCurrentNDCDetailsSelected(response?.data[0], 'All'));
      redirectURLLink('/ndc-details', 'NDC Details', history, dispatch);
    }
  };

  // Go to Provider Redirection API call
  const goToProvider = async (cellInfo, data) => {
    setLoading(true);
    const payload = {
      providerId: cellInfo.providerId,
      providerIdTypeCd: cellInfo.providerIdTypeCd,
    };
    dispatch(getProviderIdTypeDetails());
    dispatch(
      navigateToProvider(payload, () => {
        redirectURLLink(
          '/ProviderDetails',
          'Provider Details',
          history,
          dispatch
        );
      })
    );
  };

  // Handle Existing Comments & Correspond
  const handleExistingCommentList = async (data, name) => {
    if (data && data.length > 0) {
      const result = await getExistingCorrLinkIds({
        corrLinkId: data.map((item) => {
          return item.claimCorrLinkId;
        }),
      });
      let arrayList = [];
      arrayList =
        data &&
        data.map((item) => {
          if (
            result?.data.length > 0 &&
            result?.data.filter((x) => {
              return x === item.claimCorrLinkId;
            }).length > 0
          ) {
            item.ccCommentsExist = 1;
          } else {
            item.ccCommentsExist = 0;
          }
          return item;
        });

      setClaimAuditTable(arrayList);
      // setAuditDescriptionTable(arrayList);
    } else {
      setClaimAuditTable([]);
      // setAuditDescriptionTable([]);
    }
  };

  const handleScrollToEvent = () => {
    window.scrollTo(0, 0);
  };
  const claimCategoryCode = useSelector(
    (state) => state?.sharedState?.ClaimAuditReducer?.claimCategoryCode
  );
  // Fetching Header input fields data
  React.useEffect(() => {
    if (claimAuditDetails?.message === 'Success') {
      setLoading(false);
      handleScrollToEvent();
      let list = [];
      list = claimAuditDetails?.claimAuditResponse?.map((data) => {
        const categoryInfo = claimCategoryCode.CLAIM_CATEGORY_CD.find(
          (ob) => ob.codeValueID.codeValue === data.claimCategoryCd
        );
        return {
          claimid: data?.claimId,
          claimlinenum: data?.claimLineNum,
          category: categoryInfo?.shortDescription,
          auditCounts: data?.claimAuditCounts,
          drugSeqNum: data?.drugSeqNum,
          drugName: data?.drugName,
          ndc: `${data?.labelerCode}-${data?.productCode}-${data?.packageSize}`,
          providerId: data?.providerId,
          providerIdTypeCd: data?.providerIdTypeCd,
          claimCorrLinkId: data?.claimCorrLinkId,
          corrLinkId: data?.corrLinkId,
          paidDt: data.paidDt,
          claimReversalInd: data?.claimReversalInd,
        };
      });
      handleExistingCommentList(list);
    }
  }, [claimAuditDetails]);

  React.useEffect(() => {
    if (claimAuditDescription?.message === 'Success') {
      dispatch(dispatchClaimAuditDescription(claimAuditDescription));
    }
  }, []);

  // Audit description data handling
  React.useEffect(() => {
    if (claimAuditDescription?.message === 'Success') {
      setLoading(false);

      const list = claimAuditDescription?.claimAuditResponse?.map(
        (data, index) => {
          const checkClearedList = !_.isEmpty(changesDataList)
            ? _.filter(
                changesDataList,
                (l) =>
                  l.claimId === data.claimId &&
                  l.drugSeqNum === data.drugSeqNum &&
                  l.auditType === data.claimAuditTypeCd
              )
            : [];
          return {
            cleared:
              checkClearedList?.length > 0
                ? checkClearedList[0]?.cleared
                : data?.auditClearedInd,
            drugSeqNum: data.drugSeqNum,
            auditType: data?.claimAuditTypeCd,
            auditDescription: data?.auditText,
            claimId: data?.claimId,
            claimLineNum: data?.claimLineNum,
            ccCommentExist: data?.ccCommentExist,
            id: index + 1,
            claimCorrLinkId: data?.claimCorrLinkId,
          };
        }
      );
      // setAuditDescriptionTable(list);
      handleExistingCommentList2(list);
      if (claimAuditDescription?.length < 1 && list?.length) {
        setTotalCount(list.length);
      }
    }
  }, [claimAuditDescription]);
  const handleExistingCommentList2 = async (data, name) => {
    if (data && data.length > 0) {
      const result = await getExistingCorrLinkIds({
        corrLinkId: data.map((item) => {
          return item.claimCorrLinkId;
        }),
      });
      let arrayList = [];
      arrayList =
        data &&
        data.map((item) => {
          if (
            result?.data.length > 0 &&
            result?.data.filter((x) => {
              return x === item.claimCorrLinkId;
            }).length > 0
          ) {
            item.ccCommentsExist = 1;
          } else {
            item.ccCommentsExist = 0;
          }
          return item;
        });

      // setClaimAuditTable(arrayList);
      setAuditDescriptionTable(arrayList);
    } else {
      // setClaimAuditTable([]);
      setAuditDescriptionTable([]);
    }
  };

  // Handling after Save data
  React.useEffect(() => {
    if (updateClearedResponse?.message === 'Success') {
      if (!clickOncloseTabBtn) {
        closeTab('/ClaimAuditViewDetails', history);
      }
      setOpen(false);
      setSuccessMessages([SUCCESSMESSAGE_GENERIC]);
      // eslint-disable-next-line no-unused-expressions
      tableGridApi?.api?.refreshCells();
      setButtonDisable((prev) => ({
        ...prev,
        save: true,
        cancel: true,
      }));
      if (movePage) {
        setSuccessMessages([]);
        dispatch(dispatchUpdateClr([]));
        setAuditDescriptionTable([]);
        dispatch(dispatchClaimAuditDescription([]));
        const obj = {};
        obj.pageCount = claimPageDetails.pageCount - 1;
        obj.inputList =
          claimAuditDetail?.claimAuditResponse[claimPageDetails.pageCount - 2];
        dispatch(dispatchPageCountwithDetails(obj));
        setMovePage(false);
      }
      if (moveRight) {
        setSuccessMessages([]);
        dispatch(dispatchUpdateClr([]));
        const obj = {};
        obj.pageCount = claimPageDetails.pageCount + 1;
        obj.inputList =
          claimAuditDetail?.claimAuditResponse[claimPageDetails.pageCount];
        dispatch(dispatchPageCountwithDetails(obj));
        setMoveRight(false);
      }

      if (!moveRight && !movePage) {
        getTableList();
      }
    }
  }, [updateClearedResponse, claimPageDetails]);

  // Go to claim details redirection API Call
  const redirectClaim = (cellInfo) => {
    dispatch(
      getClaimDetails({
        claimId: cellInfo?.claimid,
        claimLineNum: cellInfo?.claimlinenum,
        eventInquryKeyVO: [
          {
            keyType: 'Claim ID',
            key: `${cellInfo?.claimid}-${cellInfo?.claimlinenum}`,
          },
        ],
        functionCode: 'Claim',
        userID: logInUser.toUpperCase(),
      })
    );
    const Obj = [
      {
        claimVOList: [
          {
            drugVO: {
              ...cellInfo,
              drugName: cellInfo?.drugName,
              ndc: cellInfo?.ndc,
            },
          },
        ],
      },
    ];
    dispatch(setSelectedClaim(Obj));
    redirectURLLink(
      `/claimDetails/${cellInfo.claimid}`,
      `Claim Details [${cellInfo?.claimid}]`,
      history,
      dispatch
    );
  };
  const handleCheckClearAuditsCount = async () => {
    const itemList = [];
    setCLearAuditCount(0);
    setAuditFilterData([]);
    let auditCount = 0;
    const tempObj = claimAuditTable?.filter((x) => {
      return x.ndc === selectedAuditType?.ndc;
    });
    for (let i = 0; i < tempObj?.length; i += 1) {
      const result = await dispatch(
        getClaimAuditDescription({
          drugseqnum: tempObj[i]?.drugSeqNum,
          claimId: tempObj[i]?.claimid,
          claimLineNum: tempObj[i]?.claimlinenum,
          claimReversalInd: tempObj[i]?.claimReversalInd,
          auditClearedInd: searchClaimAuditSelectData?.searchData?.clearAudit,
          claimaudittype: searchClaimAuditSelectData?.searchData?.auditType,
          claimspctype: searchClaimAuditSelectData?.searchData?.speAuditType,
          claimgrptypeUA:
            searchClaimAuditSelectData?.searchData?.amountAudit === 1
              ? 'UA'
              : null,
          claimgrptypeUCA:
            searchClaimAuditSelectData?.searchData?.unitConversionAudit === 1
              ? 'UCA'
              : null,
          claimgrptypeOA:
            searchClaimAuditSelectData?.searchData?.otherAudit === 1
              ? 'OA'
              : null,
        })
      );
      if (result.payload.claimAuditResponse?.length > 0) {
        result.payload.claimAuditResponse.forEach((data, index) => {
          if (
            selectedAuditType?.auditTypeCd === 'All' ||
            data.claimAuditTypeCd?.trim() ===
              selectedAuditType?.auditTypeCd?.trim()
          ) {
            auditCount += parseInt(data.auditClearedInd, [0, 1]) === 0 ? 1 : 0;
          }
          itemList.push({
            cleared:
              selectedAuditType?.auditTypeCd === 'All' ||
              data.claimAuditTypeCd?.trim() ===
                selectedAuditType?.auditTypeCd?.trim()
                ? 1
                : 0,
            drugSeqNum: data.drugSeqNum,
            auditType: data?.claimAuditTypeCd,
            auditDescription: data?.auditText,
            claimId: data?.claimId,
            claimLineNum: data?.claimLineNum,
            ccCommentExist: data?.ccCommentExist,
            id: index + 1,
            claimCorrLinkId: data?.claimCorrLinkId,
          });
        });
      }
    }
    setCLearAuditCount(auditCount);
    setAuditFilterData(itemList);
    if (auditCount > 0) {
      setButtonDisable((prev) => ({
        ...prev,
        save: false,
        cancel: false,
      }));
      setCancelAuditAlert(true);
      setWarningAlert(false);
    } else {
      setWarningAlert(true);
      setCancelAuditAlert(false);
    }
  };
  // Checkbox data handling
  React.useEffect(() => {
    if (selectedAuditType && clearAuditPopup) {
      setAuditDescriptionTable([]);
      handleCheckClearAuditsCount();
      setClearAuditPopup(false);
      
    }
  }, [selectedAuditType]);

  const handleAllAuditDescriptionAPIcall = async () => {
    if (claimAuditTable?.length > 0) {
      const itemList = [...changesDataList];
      if (clearAuditCount === 0) {
        setButtonDisable({ save: true, cancel: true });
      }

      dispatch(setChangesDataList([...itemList, ...auditFilterData]));
      const updatedList = auditDescriptionTable?.map((data) => {
        const obj = data;
        obj.claimAuditTypeCd = data.auditType;
        obj.auditText = data.auditDescription;
        obj.claimId = data.claimId;
        obj.claimLineNum = data.claimLineNum;
        obj.auditClearedInd = data.cleared;
        const newObj1 = _.cloneDeep(obj);
        newObj1.drugSeqNum = data.drugSeqNum;
        if (selectedAuditType?.auditTypeCd === 'All') {
          obj.auditClearedInd = 1;
          newObj1.cleared = 1;
          return obj;
        }
        if (data.auditType === selectedAuditType?.auditTypeCd) {
          obj.auditClearedInd = 1;
          newObj1.cleared = 1;
          return obj;
        }
        return obj;
      });
      const obj = {
        status: '001',
        message: 'Success',
        claimAuditResponse: updatedList,
      };
      dispatch(dispatchClaimAuditDescription(obj));
    }
  };

  // Dropdown data selection
  const chooseActions = (data, id) => {
    dispatch(storeClaimAction(data));
    setClearAuditPopup(true);
    setClearAuditData({
      ndc: id.ndc,
      drugName: id.drugName,
    });
    dispatch(
      getSpecificAuditTypeData({
        domainKey: 'AUDIT_TYPE_CD',
        codeValue: 'C',
      })
    );
  };

  // Submit data on Click on save button
  const onSubmit = (value) => {
    setClickOncloseTabBtn(value);
    const payload = [];
    if (changesDataList?.length > 0) {
      changesDataList.forEach((li) => {
        const obj = {};
        obj.claimAuditId = {
          claimId: li.claimId,
          claimLineNum: li.claimLineNum,
          claimAuditTypeCd: li.auditType,
        };
        obj.auditClearedInd = li.cleared;
        obj.claimspctype = searchClaimAuditSelectData?.searchData?.speAuditType;
        obj.claimgrptypeUA =
          searchClaimAuditSelectData?.searchData?.amountAudit === 1
            ? 'UA'
            : null;
        obj.claimgrptypeUCA =
          searchClaimAuditSelectData?.searchData?.unitConversionAudit === 1
            ? 'UCA'
            : null;
        obj.claimgrptypeOA =
          searchClaimAuditSelectData?.searchData?.otherAudit === 1
            ? 'OA'
            : null;
        obj.lastUpdateUserId = logInUserID || logInUser;
        payload.push(obj);
      });
      setClearedIndexPayload(payload);
      if (!value) {
        dispatch(setChangesDataList([]));
        dispatch(updateClearedIndex(payload));
      }
    }
  };

  // Pagination right arrow click function
  const clickNextRow = () => {
    // if (buttonDisable.save) {
    setSuccessMessages([]);
    setErrorMessages([]);
    dispatch(dispatchUpdateClr([]));
    const obj = {};
    obj.pageCount = claimPageDetails.pageCount + 1;
    obj.inputList =
      claimAuditDetail?.claimAuditResponse[claimPageDetails.pageCount];
    dispatch(dispatchPageCountwithDetails(obj));
    setMoveRight(false);
    // } else {
    //   onSubmit(true);
    //   setMoveRight(true);
    //   setOpen(true);
    // }
  };

  // Pagination left arrow click function
  const clickPrevious = () => {
    // if (buttonDisable?.save) {
    setSuccessMessages([]);
    setErrorMessages([]);
    dispatch(dispatchUpdateClr([]));
    const obj = {};
    obj.pageCount = claimPageDetails.pageCount - 1;
    obj.inputList =
      claimAuditDetail?.claimAuditResponse[claimPageDetails.pageCount - 2];
    dispatch(dispatchPageCountwithDetails(obj));
    setMovePage(false);
    // } else {
    //   onSubmit(true);
    //   setMovePage(true);
    //   setOpen(true);
    // }
  };

  // Pagination input field change function
  const handlePage = (e) => {
    // if (buttonDisable?.save) {
    setSuccessMessages([]);
    dispatch(dispatchUpdateClr([]));
    const count = Number(e.target.value);
    setErrorMessages([]);

    const obj = {};
    obj.pageCount = count;
    obj.inputList = claimAuditDetail?.claimAuditResponse[count - 1];
    if (count !== 0) {
      if (count <= totalCount) {
        setDisableBtn(false);
      } else {
        obj.pageCount = count;
        obj.inputList = claimPageDetails?.inputList;
        setDisableBtn(true);
      }
    } else {
      obj.pageCount = 0;
      obj.inputList = claimPageDetails?.inputList;
      setDisableBtn(true);
    }
    dispatch(dispatchPageCountwithDetails(obj));
    // } else {
    //   setOpen(true);
    // }
  };

  const onBlurPage = () => {
    if (claimPageDetails?.pageCount !== 0) {
      if (claimPageDetails?.pageCount <= totalCount) {
        setErrorMessages([]);
        dispatch(dispatchErrorMessageData());
      } else {
        setErrorMessages([INPUT_VALUE_GRETER_THAN_TOTAL_COUNT]);
        dispatch(dispatchErrorMessageData(INPUT_VALUE_GRETER_THAN_TOTAL_COUNT));
      }
    } else {
      setErrorMessages([ERR_PAGINATE_VALUE]);
      dispatch(dispatchErrorMessageData(ERR_PAGINATE_VALUE));
    }
  };

  React.useEffect(() => {
    if (errorMessageInRedux) {
      setErrorMessages([errorMessageInRedux]);
    }
  }, [errorMessageInRedux]);

  const handelSaveClose = () => {
    setErrorMessages([])
    setOpen(false);
  };

  const handelCancelClose = () => {
    setErrorMessages([])
    setOpenCancel(false);
  };

  const onGridReady = (params) => {
    setGridApi(params.api);
    setTableGridApi(params);
  };
  const onGridReadyForAudit = (params) => {
    setGridApi(params.api);
    setTableGridApiForAudit(params);
  };

  //  row selection function
  const onRowSelect = (row) => {
    setErrorMessages([])
    setSuccessMessages([]);
    dispatch(dispatchUpdateClr([]));
    setAuditDescriptionTable([]);
    // Check if row is empty
    if (!row || Object.keys(row).length === 0) {
      dispatch(getClaimAuditDescription({}));
      return;
    }
    dispatch(
      getClaimAuditDescription({
        drugseqnum: row.drugSeqNum,
        claimId: row.claimid,
        claimLineNum: row.claimlinenum,
        claimReversalInd: row.claimReversalInd,
        auditClearedInd: searchClaimAuditSelectData?.searchData?.clearAudit,
        claimaudittype: searchClaimAuditSelectData?.searchData?.auditType,
        claimspctype: searchClaimAuditSelectData?.searchData?.speAuditType,
        claimgrptypeUA:
          searchClaimAuditSelectData?.searchData?.amountAudit === 1
            ? 'UA'
            : null,
        claimgrptypeUCA:
          searchClaimAuditSelectData?.searchData?.unitConversionAudit === 1
            ? 'UCA'
            : null,
        claimgrptypeOA:
          searchClaimAuditSelectData?.searchData?.otherAudit === 1
            ? 'OA'
            : null,
      })
    );
  };

  React.useEffect(() => {
    if (claimAuditTable?.length > 0) {
      setTableState(true);
      if (tableGridApi?.columnApi && tableGridApi?.columnApi !== null) {
        tableGridApi.columnApi.applyColumnState({
          state: [{ colId: 'claimid', sort: 'asc' }],
        });
      }
      const selectRow = claimAuditTable?.sort((a, b) => {
        return parseFloat(a.claimid) - parseFloat(b.claimid);
      })[0];
      dispatch(
        getClaimAuditDescription({
          drugseqnum: selectRow?.drugSeqNum,
          claimId: selectRow?.claimid,
          claimLineNum: selectRow?.claimlinenum,
          claimReversalInd: selectRow?.claimReversalInd,
          auditClearedInd: searchClaimAuditSelectData?.searchData?.clearAudit,
          claimaudittype: searchClaimAuditSelectData?.searchData?.auditType,
          claimspctype: searchClaimAuditSelectData?.searchData?.speAuditType,
          claimgrptypeUA:
            searchClaimAuditSelectData?.searchData?.amountAudit === 1
              ? 'UA'
              : null,
          claimgrptypeUCA:
            searchClaimAuditSelectData?.searchData?.unitConversionAudit === 1
              ? 'UCA'
              : null,
          claimgrptypeOA:
            searchClaimAuditSelectData?.searchData?.otherAudit === 1
              ? 'OA'
              : null,
        })
      );

      tableGridApi.api.forEachNode(
        (node) => node.rowIndex === 0 && node.setSelected(true)
      );
      tableGridApi.api.setFilterModel(null);
    }
  }, [claimAuditTable]);

  // handing view History popup
  const handleViewHistory = (api) => {
    setShowViewHistory(true);
    setErrorMessages([])
    const selectedRow = api.getSelectedRows()?.[0];
    const temp = {
      CLAIM_ID: selectedRow.claimid,
      CLAIM_LINE_NUM: selectedRow.claimlinenum,
      CLAIM_AUDIT_TYPE_CD:
        claimAuditDescription &&
        claimAuditDescription?.claimAuditResponse[0]?.claimAuditTypeCd,
    };
    setKeyValue(temp);
  };

  React.useEffect(() => {
    dispatch(dispatchUpdateClr({}));
  }, []);

  // Close Tab functionality
  React.useEffect(() => {
    if (updateClearedResponse?.message !== 'Success') {
      if (
        updateTabs &&
        updateTabs.length > 0 &&
        updateTabs.filter((x) => {
          return x.navTo === '/ClaimAuditViewDetails';
        }).length > 0
      ) {
        const newObj = updateTabs.map((item) => {
          if (item.navTo === '/ClaimAuditViewDetails' && !buttonDisable.save) {
            item.isFormDirty = true;
          } else if (item.navTo === '/ClaimAuditViewDetails')
            item.isFormDirty = false;
          return item;
        });
        localStorage.setItem('tabItemsData', JSON.stringify(newObj));
      }
    } else {
      const newObj = updateTabs.map((item) => {
        if (item.navTo === '/ClaimAuditViewDetails' && buttonDisable.save)
          item.isFormDirty = false;
        return item;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [!buttonDisable.save]);

  React.useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    if (
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.filter((x) => {
        return x.navTo === '/ClaimAuditViewDetails' && x.isFormSave;
      }).length > 0
    ) {
      const newObj = updateTabs.map((item) => {
        if (item.navTo === '/ClaimAuditViewDetails' && item.isFormSave) {
          item.isFormSave = false;
          onSubmit(false);
        }
        return item;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [JSON.parse(localStorage.getItem('tabItemsData'))]);

  // handing highlight tab
  React.useEffect(() => {
    if (updateClearedResponse?.message !== 'Success') {
      if (errorMessageInRedux && errorMessageInRedux.length > 0) {
        tabHighLigther('/ClaimAuditViewDetails', true);
      } else {
        tabHighLigther('/ClaimAuditViewDetails', false);
      }
    }
  }, [JSON.stringify(errorMessageInRedux)]);

  // handing Unit conversion page redirect
  const handleViewDetailsClaimDetails = async (data) => {
    setLoading(true);
    dispatch(
      getUnitConversionDetail({
        drugSeqNum: [claimPageDetails?.inputList?.drugSeqNum],
      })
    );
    const result = await dispatch(
      getNdcGrid({
        drugSeqNum: claimPageDetails?.inputList?.drugSeqNum,
      })
    );
    if (result.payLoad && result.payLoad?.length > 0) {
      redirectURLLink(
        '/unitConversion-detail',
        'Display Unit Conversion for NDC',
        history,
        dispatch
      );
    } else {
      setLoading(false);
      handleScrollToEvent();
      setSuccessMessages([]);
      dispatch(dispatchUpdateClr([]));
      setErrorMessages([MNFC_NDC_ERROR_MSG]);
    }
  };

  React.useEffect(() => {
    if (getExportAllDataForDetailScr?.message === 'Success') {
      const list = getExportAllDataForDetailScr?.claimAuditResponse?.map(
        (data, index) => {
          return {
            RebateProgram: data?.rebateProgramCd,
            manufacturer: data?.mfgName,
            Paid_Qtr: data?.paidDt,
            Ndc: `${data?.labelerCode}-${data?.productCode}-${data?.packageSize}`,
            ClaimId: data?.claimId,
            ClaimlLineNumber: data?.claimLineNum,
            Category: data?.claimCategoryCd,
            ClaimReversed: data?.claimReversalInd,
            Audits: data?.claimAuditCounts,
            ClaimComments: data?.ccCommentExist,
            AuditClearedInd: data?.auditClearedInd,
            ClaimAuditTypeCd: data?.claimAuditTypeCd,
            AuditText: data?.auditText,
            AuditComments: data?.ccCommentExist,
          };
        }
      );
      setExportExcel(list);
    }
  }, [getExportAllDataForDetailScr]);

  React.useEffect(() => {
    setSuccessMessages([]);
  }, []);

  // check if any comment add on particular ccCommentsExist value
  React.useEffect(() => {
    if (
      showComments &&
      claimAuditTable &&
      claimAuditTable.length > 0 &&
      linkTableName === 'CLAIM'
    ) {
      setStateCC(false);
      const tempObj = claimAuditTable.map((item) => {
        if (
          item.claimCorrLinkId === corrLinkId &&
          commentsList &&
          commentsList.length > 0
        ) {
          setStateCC(false);
          item.ccCommentsExist = 1;
        } else if (item.claimCorrLinkId === corrLinkId) {
          item.ccCommentsExist = 0;
        }

        return item;
      });
      setStateCC(true);

      setClaimAuditTable(tempObj);

      // eslint-disable-next-line no-unused-expressions
      handleRefreshCell(tableGridApi);
    }
    if (
      showComments &&
      auditDescriptionTable &&
      auditDescriptionTable.length > 0 &&
      linkTableName === 'CLAIM_AUDIT'
    ) {
      setStateCC(false);
      const tempObj = auditDescriptionTable.map((item) => {
        if (
          item.claimCorrLinkId === corrLinkId &&
          commentsList &&
          commentsList.length > 0
        ) {
          setStateCC(false);
          item.ccCommentsExist = 1;
        } else if (item.claimCorrLinkId === corrLinkId) {
          item.ccCommentsExist = 0;
        }

        return item;
      });
      setStateCC(true);

      setAuditDescriptionTable(tempObj);
      dispatch(dispatchClaimAuditDescription(tempObj));

      // eslint-disable-next-line no-unused-expressions
      handleRefreshCell(tableGridApiForAudit);
    }
  }, [commentsList]);

  React.useEffect(() => {
    if (!_.isEmpty(selectedData)) {
      let newData = _.cloneDeep(changesDataList);
      const alList = [];
      _.forEach(selectedData, (data) => {
        const checkList = !_.isEmpty(changesDataList)
          ? _.filter(
              changesDataList,
              (l) =>
                l.claimId === data.claimId &&
                l.auditType === data.auditType &&
                (l.cleared === data.cleared || l.cleared !== data.cleared)
            )
          : [];
        if (_.isEmpty(checkList)) {
          newData.push(data);
        } else if (checkList.cleared !== data.cleared) {
          alList.push(data);
          // newData = _.filter(newData, l => l.claimId !== data.claimId)
        }
      });

      if (!_.isEmpty(alList)) {
        newData = _.filter(newData, (l) => {
          const al = _.filter(
            alList,
            (x) => l.claimId === x.claimId && l.auditType === x.auditType
          );
          if (!_.isEmpty(al)) {
            const flData = al[0];
            if (l.cleared !== flData.cleared) {
              l.cleared = flData.cleared;
              return l;
            }
          } else {
            return l;
          }
        });
      }
      dispatch(setChangesDataList(newData));
      setSelectedData([]);
    }
  }, [selectedData]);

  const qtrtodate = (qtr, notate) => {
    const period = qtr.substr(0, 2);
    if (notate === 'from') {
      if (period === '1Q') return `01/01/${qtr.substr(2)}`;
      if (period === '2Q') return `04/01/${qtr.substr(2)}`;
      if (period === '3Q') return `07/01/${qtr.substr(2)}`;
      if (period === '4Q') return `10/01/${qtr.substr(2)}`;
    }
    if (notate === 'to') {
      if (period === '1Q') return `03/31/${qtr.substr(2)}`;
      if (period === '2Q') return `06/30/${qtr.substr(2)}`;
      if (period === '3Q') return `09/30/${qtr.substr(2)}`;
      if (period === '4Q') return `12/31/${qtr.substr(2)}`;
    }
  };
  return (
    <div className=" tabs-container" data-testid="claim-audit-detail">
      <SaveCancelPopup
        open={open}
        data-testid="savePopup"
        title="Save"
        onConfim={() => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
          dispatch(updateClearedIndex(clearedIndexPayload));
          dispatch(setChangesDataList([]));
        }}
        onCancel={() => {
          handelSaveClose();
          setMovePage(false);
          setMoveRight(false);
        }}
      />
      <SaveCancelPopup
        open={openCancel}
        data-testid="cancelPopup"
        title="Cancel"
        onConfim={() => {
          setLoading(true);
          getTableList();
          setOpenCancel(false);
          if (gridApi) {
            gridApi.deselectAll();
          }
          dispatch(setChangesDataList([]));
          setAuditDescriptionTable([]);
          setButtonDisable((prev) => ({
            ...prev,
            save: true,
            cancel: true,
          }));
          setMovePage(false);
          setMoveRight(false);
        }}
        onCancel={() => {
          handelCancelClose();
          setOpenCancel(false);
        }}
      />
      <ClearAuditsForNDCPopup
        data-testid="clearAuditPopup"
        open={clearAuditPopup}
        data={clearAuditData}
        disabledSaveCancelBtn={disabledSaveCancelBtn}
        setCancelAuditAlert={setCancelAuditAlert}
        handleClose={() => setClearAuditPopup(false)}
      />
      <CommonModal
        className="dialog-420"
        data-testid="common-modal-warning"
        open={cancelAuditAlert}
        viewAction
        viewHeader
        onOk={() => {
          setCancelAuditAlert(false);
          setClearAuditPopup(false);
          handleAllAuditDescriptionAPIcall();
        }}
        onClose={() => {
          setCancelAuditAlert(false);
          setClearAuditPopup(false);
          setButtonDisable({ save: true, cancel: true });
        }}
        okTitle="Yes"
        closeTitle="No"
        modalTitle="Display Audit Claims"
        childrenComponent={
          <div>
            {`Clear ${clearAuditCount} Audits of type '${
              selectedAuditType?.auditTypeCd || 'All'
            }' ?`}
          </div>
        }
      />
      <CommonModal
        className="dialog-420"
        data-testid="common-modal-warning"
        open={warningAlert}
        viewAction
        viewHeader
        onOk={() => {
          setWarningAlert(false);
        }}
        onClose={() => {
          setWarningAlert(false);
        }}
        okTitle="Ok"
        modalTitle="Display Audit Claims"
        childrenComponent={
          <div className="p-3">No Audits found for these criteria.</div>
        }
      />
      <Spinner load={spinnerLoader} />
      <CustomSeparator parent1="Research" parent2="Claim Audit Details" />

      <Box className="alone-pagination mb-2">
        <Box>
          <Button
            title="Previous "
            className="btns rotate-left"
            data-testid="uc-paginate-arrow-left"
            type="button"
            onClick={clickPrevious}
            disabled={!(claimPageDetails?.pageCount > 1 && !disableBtn)}
          >
            <SVGComponent iconName="Icon-arrow" />
            <span className="hide-elm">Previous</span>
          </Button>
        </Box>
        <Box>
          <label className="m-0" htmlFor="paginate-count">
            <TextField
              id="paginate-count"
              data-testid="uc-input-paginate"
              variant="outlined"
              className="searchInput input-count"
              size="small"
              value={
                claimPageDetails?.pageCount === 0
                  ? ''
                  : claimPageDetails?.pageCount
              }
              onChange={(e) => handlePage(e)}
              onBlur={onBlurPage}
            />
          </label>
        </Box>
        <Box className="btns">Of {totalCount}</Box>
        <Box>
          <Button
            title="Next "
            className="btns rotate-right ml-0"
            data-testid="uc-paginate-arrow-right"
            type="button"
            onClick={clickNextRow}
            disabled={
              !(claimPageDetails?.pageCount !== totalCount && !disableBtn)
            }
          >
            <SVGComponent iconName="Icon-arrow" />
            <span className="hide-elm">Next</span>
          </Button>
        </Box>
      </Box>
      <DisplaySuccessMessages successMessages={successMessages} />
      <DisplayErrorMessages errorMessages={errorMessages} />
      <div
        id="testGrid"
        className="panel-body FRR-custom-table tbl-manufacturer-inner frr-exportalltable"
      >
        <TableGrid
          rowSelection="single"
          data-testid="InvoiceAudit_Drugs"
          rowMultiSelectWithClick={false}
          applyFilter={false}
          gridHeight={fullScreenView1 ? '70vh' : 313}
          enterMovesDown
          suppressCellFocus
          exportWithOtherOption
          sideBar={false}
          fileName="Export All to Excel"
          columnDefs={rebateProgramColumnDetails}
          rowData={exportExcel}
          claimHandleRedirectURLLink={() => handleViewDetailsClaimDetails()}
          handleViewDetailsForClaimDetail
          frameworkComponents={{
            ActionCellRender: (cellInfo) => {
              return (
                <div
                  className="tdCell icon-btn-group d-flex"
                  data-testid="action-column"
                >
                  <Dropdown className="icon-dropdown-container">
                    <Dropdown.Toggle
                      className="icon-dropdown export_wrap"
                      aria-label="export"
                    >
                      <OverlayTrigger
                        placement="bottom"
                        overlay={<Tooltip id="action-tooltip">Actions</Tooltip>}
                      >
                        <SVGComponent iconName="Icon-export1" />
                      </OverlayTrigger>
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="export_dropdown">
                      <Dropdown.Item
                        role="button"
                        // onClick={() => logBatchTotalScreen()}
                      >
                        Export To Excel
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              );
            },
            CheckBoxCellRender: (cellInfo) => {
              return (
                <>
                  <div className="tbl-checkbox">
                    <FormControlLabel
                      data-testid="checkBox"
                      control={<Checkbox color="primary" />}
                    />
                  </div>
                </>
              );
            },
          }}
        />
      </div>
      {!fullScreenView && !fullScreenView1 && (
        <div className="row">
          <div
            className="col-12 mui-custom-form no-margin"
            style={{ width: '100%' }}
          >
            <fieldset className="custom-fieldset custom-height">
              <legend className="d-none" />
              <div className="form-wrapper db">
                <div className="row">
                  <div className="col-4">
                    <div className="form-wrapper vertical-wrapper">
                      <div className="mui-custom-form with-select input-md override-width-95 d-flex flex-column">
                        <TextField
                          data-testid="-textField"
                          id="quarter-id"
                          label="Quarter"
                          fullWidth
                          disabled
                          placeholder=""
                          value={`${claimPageDetails?.inputList?.paidDt?.substr(
                            4
                          )}Q${claimPageDetails?.inputList?.paidDt?.substr(
                            0,
                            4
                          )}`}
                          inputProps={{ maxLength: 38, id: 'quarter-id' }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="form-wrapper vertical-wrapper">
                      <div className="mui-custom-form with-select input-md override-width-95 d-flex flex-column">
                        <TextField
                          data-testid="-textField"
                          id="rebate-id"
                          label="Rebate Program"
                          fullWidth
                          disabled
                          placeholder=""
                          value={
                            searchClaimAuditSelectData?.searchData
                              ?.rebateProgramCd
                          }
                          inputProps={{ maxLength: 38 }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="form-wrapper vertical-wrapper">
                      <div className="mui-custom-form with-select input-md override-width-95 d-flex flex-column">
                        <TextField
                          data-testid="-textField"
                          id="paid-date-range-id"
                          label="Paid Date Range"
                          fullWidth
                          disabled
                          placeholder=""
                          value={`${
                            searchClaimAuditSelectData?.searchData?.paidDateRangeFrom?.includes(
                              'Q'
                            )
                              ? qtrtodate(
                                  searchClaimAuditSelectData?.searchData
                                    ?.paidDateRangeFrom,
                                  'from'
                                )
                              : searchClaimAuditSelectData?.searchData
                                  ?.paidDateRangeFrom
                          } - ${
                            searchClaimAuditSelectData?.searchData?.paidDateRangeTo.includes(
                              'Q'
                            )
                              ? qtrtodate(
                                  searchClaimAuditSelectData?.searchData
                                    ?.paidDateRangeTo,
                                  'to'
                                )
                              : searchClaimAuditSelectData?.searchData
                                  ?.paidDateRangeTo
                          }`}
                          inputProps={{
                            maxLength: 38,
                            id: 'paid-date-range-id',
                          }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-4">
                    <div className="form-wrapper vertical-wrapper">
                      <div className="mui-custom-form with-select input-md override-width-95 d-flex flex-column">
                        <TextField
                          data-testid="-textField"
                          id="manufactur-id"
                          label="Manufacturer"
                          fullWidth
                          disabled
                          placeholder=""
                          value={claimPageDetails?.inputList?.mfgName}
                          inputProps={{ maxLength: 38, id: 'manufactur-id' }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-2">
                    <div className="form-wrapper vertical-wrapper">
                      <div className="mui-custom-form with-select input-md override-width-95 d-flex flex-column">
                        <TextField
                          data-testid="-textField"
                          id="ndc-id"
                          fullWidth
                          disabled
                          label="NDC"
                          placeholder=""
                          value={`${claimPageDetails?.inputList?.labelerCode}-${claimPageDetails?.inputList?.productCode}-${claimPageDetails?.inputList?.packageSize}`}
                          inputProps={{ maxLength: 38, id: 'ndc-id' }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-2" style={{ paddingLeft: 0 }}>
                    <div className="form-wrapper vertical-wrapper">
                      <div className="mui-custom-form with-select input-md override-width-95 d-flex flex-column">
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip id="com-tooltip">
                              {claimPageDetails?.inputList?.drugName}
                            </Tooltip>
                          }
                        >
                          <TextField
                            data-testid="-textField"
                            className="frr-display-hidden-label"
                            id="drugname"
                            fullWidth
                            disabled
                            label="Drug Name"
                            placeholder=""
                            value={`${claimPageDetails?.inputList?.drugName}`}
                            inputProps={{ maxLength: 50, id: 'drugname' }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        </OverlayTrigger>
                      </div>
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="form-wrapper vertical-wrapper">
                      <div className="mui-custom-form with-select input-md override-width-95 d-flex flex-column">
                        <TextField
                          data-testid="-textField"
                          id="audit-id"
                          fullWidth
                          disabled
                          label="Audits Selected"
                          placeholder=""
                          value={
                            searchClaimAuditSelectData?.searchData?.auditType
                          }
                          inputProps={{ maxLength: 38, id: 'audit-id' }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="mui-custom-form input-md">
                    <FormControlLabel
                      className="frr-mt-26 ml-1"
                      control={<Checkbox color="primary" />}
                      label="Reversed"
                      checked={
                        parseInt(
                          searchClaimAuditSelectData?.searchData?.reversed,
                          [0, 1]
                        ) === 1
                      }
                      value={
                        parseInt(
                          searchClaimAuditSelectData?.searchData?.reversed,
                          [0, 1]
                        ) === 1
                      }
                      disabled
                    />
                  </div>
                  <div className="mui-custom-form input-md">
                    <FormControlLabel
                      className="frr-mt-26 ml-1"
                      control={<Checkbox color="primary" />}
                      label="Not Reversed"
                      checked={
                        searchClaimAuditSelectData?.searchData?.unreversed
                      }
                      value={searchClaimAuditSelectData?.searchData?.unreversed}
                      disabled
                    />
                  </div>
                  <div className="mui-custom-form input-md">
                    <FormControlLabel
                      className="frr-mt-26 ml-1"
                      control={<Checkbox color="primary" />}
                      label="Cleared Included"
                      checked={
                        searchClaimAuditSelectData?.searchData?.clearAudit
                      }
                      value={searchClaimAuditSelectData?.searchData?.clearAudit}
                      disabled
                    />
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
          <div className="col-12 log-batch-detail-btn-group welcometxt my-4">
            <div className="btn-wrapper">
              {/* <Button
                className='btn btn-success btn-save btn-primary'
                data-testid='view-history'
                onClick={() => {
                  handleViewHistory();
                }}
                type='button'
              >
                <SVGComponent iconName='Icon-view-history' /> View History
              </Button> */}
              <Button
                className="btn btn-success btn-save"
                data-testid="saveBtn"
                disabled={buttonDisable.save}
                onClick={() => {
                  onSubmit(true);
                  setOpen(true);
                }}
              >
                {' '}
                <SVGComponent iconName="Icon-awesome-save" />
                Save
              </Button>
              <Button
                className="btn btn-cancel"
                data-testid="cancelBtn"
                disabled={buttonDisable.cancel}
                onClick={() => {
                  setOpenCancel(true);
                }}
              >
                <SVGComponent iconName="Icon-cancel" />
                Cancel
              </Button>
            </div>
          </div>
        </div>
      )}
      {!fullScreenView1 && (
        <div
          id="testGrid"
          className="panel-body FRR-custom-table tbl-manufacturer-inner"
        >
          {tableState || claimAuditTable?.length === 0 ? (
            <TableGrid
              rowSelection="single"
              data-testid="InvoiceAuditType_IRGL"
              rowMultiSelectWithClick={false}
              fullScreenView={fullScreenView}
              handleFullScreenView
              handleFullScreenViewClick={() =>
                setFullScreenView(!fullScreenView)
              }
              gridHeight={fullScreenView ? '70vh' : 313}
              onSelect={(e) => onRowSelect(e.data)}
              gridCall={onGridReady}
              rowData={claimAuditTable || []}
              columnDefs={TableHeaderForNDCLevelDetail}
              animateRows
              sideBar={false}
              fileName="ClaimAuditViewDetails"
              singleClickEdit
              enterMovesDown
              suppressCellFocus
              exportFile
              handleViewHistory={handleViewHistory}
              frameworkComponents={{
                ActionCellRender: (cellInfo) => {
                  const [anchorEl, setAnchorEl] = React.useState();
                  const [openAction, setOpenAction] = React.useState(false);
                  const handleClick = (event) => {
                    setAnchorEl(event.currentTarget);
                    setOpenAction(true);
                  };
                  const handleClose = () => {
                    setOpenAction(false);
                  };
                  const searchScreenReduxObj = useSelector(
                    (state) =>
                      state.sharedState.NumberOfUnits?.searchScreenReduxObj
                  );
                  const searchClaimAuditSelectObj = useSelector(
                    (state) =>
                      state?.sharedState?.ClaimAuditReducer
                        ?.claimAuditSelectScreenData
                  );
                  const logInUser = useSelector(
                    (state) => state?.sharedState?.SharedReducer?.logInUser
                  );
                  return (
                    <div
                      className="tdCell icon-btn-group d-flex"
                      data-testid="action-column"
                    >
                      <OverlayTrigger
                        placement="bottom"
                        overlay={<Tooltip id="com-tooltip">Comment</Tooltip>}
                      >
                        <Button
                          className="th-ic comment-ic"
                          variant="text"
                          onClick={() => {
                            setCorrLinkId(
                              cellInfo && cellInfo.data.claimCorrLinkId
                            );
                            setShowComments(true);
                            setLinkTableName('CLAIM');
                            setTableName('DRUG_AUDIT_DES');
                          }}
                          tabIndex="0"
                          onKeyDown={(e) => {
                            // Handle Enter and Space key events
                            if (e.key === 'Enter' || e.key === ' ') {
                              e.preventDefault(); // Prevents the default space scrolling behavior
                              setCorrLinkId(
                                cellInfo && cellInfo.data.claimCorrLinkId
                              );
                              setShowComments(true);
                              setLinkTableName('CLAIM');
                              setTableName('DRUG_AUDIT_DES');
                            }
                          }}
                        >
                          {parseInt(cellInfo.data.ccCommentsExist, [0, 1]) ===
                          1 ? (
                            <img alt="comment" src={CommentVisibleIcon} />
                          ) : (
                            <img alt="comment" src={CommentIcon} />
                          )}
                        </Button>
                      </OverlayTrigger>
                      <IconButton
                        aria-label="export"
                        id="lng-btn"
                        aria-controls={openAction ? 'long-menu' : undefined}
                        aria-expanded={openAction ? 'true' : undefined}
                        aria-haspopup="true"
                        onClick={handleClick}
                      >
                        <SVGComponent iconName="Icon-export1" />
                      </IconButton>
                      <Menu
                        open={openAction}
                        anchorEl={anchorEl}
                        onClose={handleClose}
                        className="export_dropdown"
                      >
                        <MenuItem
                          role="button"
                          onClick={() => {
                            handleViewDetailsForUnits(
                              cellInfo?.data,
                              logInUser,
                              searchScreenReduxObj
                            );
                            setOpenAction(false);
                          }}
                        >
                          Modify Units
                        </MenuItem>
                        <MenuItem
                          role="button"
                          disabled={!isEnablebyRole}
                          onClick={() => {
                            chooseActions('clearNdc', cellInfo?.data);
                            setOpenAction(false);
                          }}
                        >
                          Clear Audits For NDC
                        </MenuItem>
                        <MenuItem
                          role="button"
                          data-testid="handleDetails"
                          onClick={() => {
                            handleViewDetailsForClaims(
                              cellInfo?.data,
                              searchClaimAuditSelectObj
                            );
                            setOpenAction(false);
                          }}
                        >
                          Go To Claims
                        </MenuItem>
                        <MenuItem
                          role="button"
                          onClick={() => {
                            getNdcData(cellInfo?.data);
                            setOpenAction(false);
                          }}
                        >
                          Go To NDC
                        </MenuItem>
                        <MenuItem
                          role="button"
                          onClick={() => {
                            goToProvider(cellInfo?.data);
                            setOpenAction(false);
                          }}
                        >
                          Go To Provider
                        </MenuItem>
                      </Menu>
                    </div>
                  );
                },
                ClaimIdCellRender: (cellInfo) => {
                  return (
                    <Link
                      to="#"
                      role="button"
                      onClick={() => redirectClaim(cellInfo?.data)}
                    >
                      {cellInfo && cellInfo.data.claimid}
                    </Link>
                  );
                },
                CheckBoxCellRender: (cellInfo) => {
                  return (
                    <>
                      <div className="tbl-checkbox frr-checkbox-no-label claimReversalInd">
                        <FormControlLabel
                          data-testid="checkBox"
                          label="checkbox"
                          control={<Checkbox color="primary" />}
                          checked={
                            parseInt(cellInfo.data.claimReversalInd, [0, 1]) ===
                            1
                          }
                          disabled
                        />
                      </div>
                    </>
                  );
                },
              }}
            />
          ) : null}
        </div>
      )}
      {!fullScreenView && (
        <div
          id="testGrid"
          className="panel-body FRR-custom-table tbl-manufacturer-inner frr-aggrid-ckekbox-claim"
        >
          {auditDescriptionTable.length > 0 ? (
            <TableGrid
              rowSelection="single-11"
              data-testid="tablegrid3"
              rowMultiSelectWithClick={false}
              fullScreenView={fullScreenView1}
              handleFullScreenView
              handleFullScreenViewClick={() =>
                setFullScreenView1(!fullScreenView1)
              }
              gridHeight={fullScreenView1 ? '70vh' : 313}
              rowData={
                claimAuditTable?.length > 0 ? auditDescriptionTable || [] : []
              }
              columnDefs={AuditDescriptionHeader}
              animateRows
              sideBar={false}
              gridCall={onGridReadyForAudit}
              fileName="AuditDescription"
              // singleClickEdit
              enterMovesDown
              suppressCellFocus
              exportFile
              frameworkComponents={{
                ActionCellRender: (cellInfo) => {
                  return (
                    <div
                      className="tdCell icon-btn-group d-flex"
                      data-testid="action-column"
                    >
                      <OverlayTrigger
                        placement="bottom"
                        overlay={<Tooltip id="com-tooltip">Comment</Tooltip>}
                      >
                        <Button
                          className="th-ic comment-ic"
                          variant="text"
                          onClick={() => {
                            setCorrLinkId(
                              cellInfo && cellInfo.data.claimCorrLinkId
                            );
                            setShowComments(true);
                            setLinkTableName('CLAIM_AUDIT');

                            setTableName('DRUG_AUDIT_DES');
                          }}
                        >
                          {parseInt(cellInfo?.data?.ccCommentsExist, [0, 1]) ===
                          1 ? (
                            <img alt="comment" src={CommentVisibleIcon} />
                          ) : (
                            <img alt="comment" src={CommentIcon} />
                          )}
                        </Button>
                      </OverlayTrigger>
                    </div>
                  );
                },
                CheckBoxCellRender: (cellInfo) => {
                  return (
                    <>
                      <div
                        className="tbl-checkbox frr-checkbox-no-label"
                        data-testid="checkbox-com"
                      >
                        <FormControlLabel
                          data-testid="checkBox"
                          control={
                            <Checkbox
                              color="primary"
                              disabled={!isEnablebyRole}
                            />
                          }
                          label="checkbox"
                          // onChange={(e)=>handleCheck(e, cellInfo, auditDescriptionTable)}
                          onClick={(e) => {
                            if (
                              isEnablebyRole &&
                              e.target.checked !== undefined
                            ) {
                              const checkedVal =
                                parseInt(cellInfo.value, [0, 1]) === 1 ? 0 : 1;
                                setErrorMessages([]);
                              cellInfo.node.setDataValue(
                                cellInfo.column.colId,
                                checkedVal
                              );
                              if (!_.isEmpty(cellInfo.data)) {
                                setSelectedData([cellInfo.data]);
                                setButtonDisable((prev) => ({
                                  ...prev,
                                  save: false,
                                  cancel: false,
                                }));
                              }
                            }
                          }}
                          checked={
                            parseInt(cellInfo.data.cleared, [0, 1]) === 1
                          }
                          value={parseInt(cellInfo.data.cleared, [0, 1]) === 1}
                          disabled={!isEnablebyRole}
                        />
                      </div>
                    </>
                  );
                },
              }}
            />
          ) : (
            ''
          )}
        </div>
      )}
      {showViewHistory && (
        <ViewHistoryComponent
          setShowViewHistory={setShowViewHistory}
          tableName="CLAIM_AUDIT"
          keyValue={keyValue}
          isSpinner
        />
      )}
      {showComments ? (
        <CommentAndCorrespondenceComponent
          setShowComments={setShowComments}
          linkTableName={linkTableName}
          corrLinkId={corrLinkId}
          rowGridPrimaryKey={null}
        />
      ) : null}
    </div>
  );
};

export default ClaimAuditViewDetails;
